import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { OupService } from "./oup.service";
import { InitResolver } from "./init.resolver";
import { DataService } from "./data.service";
import { SettingService } from "./setting.service";
import { JwtResolver } from "./jwt.resolver";

@Injectable({ providedIn: 'root' })
export class DeepLinkResolver implements Resolve<any> {
	constructor(private datas:DataService, private settings: SettingService, private router: Router, private oups: OupService, private initResolver: InitResolver, private jwtResolver:JwtResolver) { }

	async resolve(route: ActivatedRouteSnapshot): Promise<any> {
		// 客戶端登入跳轉的URL範例
		// 留意 &amp; 是 HTML escape code, 實際上是 &
		const rawSearch = window.location.search; // 例如 "?module=licensed&amp;packID=61&amp;clientId=oup&amp;esaToken=abc123"
		// 解碼 HTML 實體
		const decodedSearch = rawSearch.replace(/&amp;/g, '&');
		// 使用 URLSearchParams 解析
		const params = new URLSearchParams(decodedSearch);

		const esaToken = params.get('esaToken')?.toLowerCase();
		const clientId = params.get('clientId')?.toLowerCase();
		if (clientId == 'oup' && esaToken) {
			(window as any).isDeepLink = true;
			this.oups.signinRedirectWithEsaToken();
			return null;
		}

		// if (route.queryParams.jwt) {
        //     this.datas.jwt = route.queryParams.jwt;
        //     localStorage.setItem('common_jwt', this.datas.jwt);
        // } else {
        //     this.datas.jwt = localStorage.getItem('common_jwt');
        // }
        // if (this.datas.jwt) {
        //     try {
        //     let jwts:string[] = this.datas.jwt.split('.');
        //     this.datas.jwtObj = JSON.parse(atob(jwts[1]));
        //     this.settings.loadData();
        //     } catch (e) {
		// 		console.log('DeepLinkResolver jwt error', e); 
        //     }
        // }
		await this.jwtResolver.resolve(route);
		await this.initResolver.resolve(route);
		return true;
	}
}